var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArticle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 15.812,
    viewBox: "0 0 22 15.812",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-362 -267.094)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M383.684,268.578a10.314,10.314,0,0,0-5.528-1.484A10.551,10.551,0,0,0,373,268.353a10.551,10.551,0,0,0-5.156-1.259,10.321,10.321,0,0,0-5.529,1.484.687.687,0,0,0-.315.578v13.063a.687.687,0,0,0,1.06.577,9.679,9.679,0,0,1,9.568,0,.683.683,0,0,0,.744,0,9.681,9.681,0,0,1,9.569,0,.687.687,0,0,0,1.059-.577V269.156A.686.686,0,0,0,383.684,268.578Zm-11.371,12.493a11.4,11.4,0,0,0-8.938-.005V269.544a9.8,9.8,0,0,1,8.938.006Zm10.312-.005a11.4,11.4,0,0,0-8.937.005V269.55a9.8,9.8,0,0,1,8.937-.006Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M370.4,273.565a11.92,11.92,0,0,0-5.114,0,.688.688,0,0,0,.3,1.342,10.493,10.493,0,0,1,4.511,0,.721.721,0,0,0,.152.016.687.687,0,0,0,.15-1.358Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M365.287,270.809a.688.688,0,0,0,.3,1.342,10.526,10.526,0,0,1,4.511,0,.723.723,0,0,0,.152.017.688.688,0,0,0,.15-1.359A11.951,11.951,0,0,0,365.287,270.809Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M370.4,276.309a11.951,11.951,0,0,0-5.114,0,.688.688,0,0,0,.3,1.342,10.526,10.526,0,0,1,4.511,0,.723.723,0,0,0,.152.017.688.688,0,0,0,.15-1.359Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M380.713,273.565a11.915,11.915,0,0,0-5.113,0,.688.688,0,0,0,.3,1.342,10.5,10.5,0,0,1,4.512,0,.706.706,0,0,0,.151.016.687.687,0,0,0,.15-1.358Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M375.6,270.809a.688.688,0,1,0,.3,1.342,10.531,10.531,0,0,1,4.512,0,.707.707,0,0,0,.151.017.688.688,0,0,0,.15-1.359A11.947,11.947,0,0,0,375.6,270.809Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M380.713,276.309a11.947,11.947,0,0,0-5.113,0,.688.688,0,1,0,.3,1.342,10.531,10.531,0,0,1,4.512,0,.707.707,0,0,0,.151.017.688.688,0,0,0,.15-1.359Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticle);
export default __webpack_public_path__ + "static/media/article.45044bea8f90316a4782fcda66d59da2.svg";
export { ForwardRef as ReactComponent };